
import { Style } from '@mui/icons-material';
import { colors } from '@mui/material';

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12,
        },
      },
      variants: [
        {
          props: { variant: 'serviceMethodHeaders' },
          style: {
            fontSize: '16px',
            fontWeight: 500,
            color:'ponk'
          },
        },
      ],
    },
  };
}
